import { View } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { SelectProductsList } from "@repo/core/components/layout/SelectProductsList";
import { SelectProductController } from "@repo/core/screens/ProposalEffectiveFlows/SelectProduct/controller";

const SelectProduct = () => {
  const {
    isMobile,
    selectedProductId,
    products,
    handleOnSubmitForm,
    handleGoBack,
    handleSelectProduct
  } = SelectProductController();
  return (
    <Scaffolds.Root
      minHeight="$100vh"
      title="Selecione o produto"
      onBackPress={handleGoBack}
      showBackButtonOnWeb
    >
      <Scaffolds.Form
        showHeader={false}
        centerFormContent={false}
        footerContent={
          <View
            w="$full"
            gap="$4"
            flexDirection={!isMobile ? "row-reverse" : "column"}
            pt={isMobile ? "$4" : "$12"}
            px="$4"
            pb="$4"
            justifyContent="flex-end"
          >
            <Button
              size="xl"
              isDisabled={!selectedProductId}
              action={selectedProductId ? "primary" : "secondary"}
              text="Salvar"
              w="$full"
              onPress={handleOnSubmitForm}
            />
          </View>
        }
      >
        <View flex={1}>
          <SelectProductsList
            products={products}
            selectedProduct={selectedProductId}
            onSelectProduct={handleSelectProduct}
          />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};
export default SelectProduct;
